import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { X, ArrowLeft } from "lucide-react";
import api from "../api/api";
import { useTranslation } from "react-i18next";
import "../css/ReqDrawer.css";

// Reclamation Drawer: form with phone number, message, and send button.
// Usage: <ReclamationDrawer isOpen={show} onClose={()=>setShow(false)} anchor={{ right: '20px', bottom: '90px' }} />

export default function ReclamationDrawer({ isOpen, onClose, anchor = { right: '20px', bottom: '90px' }, refreshReclamations }){
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const { t } = useTranslation();
  const [status, setStatus] = useState(null); // { type: 'success'|'error', text }

  useEffect(() => {
    if (!isOpen) {
      setPhone("");
      setMessage("");
      setStatus(null);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => (document.body.style.overflow = '');
  }, [isOpen]);

  if (!isOpen) return null;

  const validatePhone = (p) => {
    // simple validation: digits, + and spaces allowed, min 7 digits
    const digits = p.replace(/\D/g, "");
    return digits.length >= 7;
  };

  const handleSend = async (e) => {
    e.preventDefault();
    setStatus(null);
    if (!validatePhone(phone)) {
      setStatus({ type: 'error', text: t('validPhoneNumber')});
      return;
    }
    if (!message.trim()) {
      setStatus({ type: 'error', text: t('writeMessage') });
      return;
    }

    setSending(true);
    try {
      const uid = JSON.parse(localStorage.getItem('user') || '{}').id;
      const payload = { phone, message, uid };
      await api.post('/reclamations', payload);
      setStatus({ type: 'success', text: t('reclamationSent') });
      setPhone("");
      setMessage("");
      if (typeof refreshReclamations === "function") {
        refreshReclamations();
      }
    } catch (err) {
      console.error(err);
      setStatus({ type: 'error', text: t('failedToSend') });
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <div className="sf-req-overlay" onClick={onClose} aria-hidden />

      <div className="sf-req-drawer" style={{ right: anchor.right || '20px', bottom: anchor.bottom || '90px' }}>
        <div className="sf-req-header">
          <button className="sf-req-icon-btn" onClick={onClose} aria-label={t("back", "Retour")}><ArrowLeft size={18} /></button>
          <div className="sf-req-title">{t("Reclamation")}</div>
          <button className="sf-req-icon-btn" onClick={onClose} aria-label={t("close", "Fermer")}><X size={18} /></button>
        </div>

        <div className="sf-req-body">
          <form className="sf-req-form" onSubmit={handleSend}>
            <label className="sf-req-label">{t("phoneNumber")}</label>
            <input
              type="tel"
              className="sf-req-input"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+39 333 123 4567"
            />

            <label className="sf-req-label mt-2">{t("message")}</label>
            <textarea
              className="sf-req-textarea"
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={t("describeIssue")}
            />

            {status && (
              <div className={`sf-req-status ${status.type === "success" ? "sf-req-status-success" : "sf-req-status-error"}`}>{status.text}</div>
            )}

            <div className="sf-req-actions">
              <button type="submit" className="sf-req-send-btn" disabled={sending}>
                {sending ? t("sending", "Envoi en cours...") : t('send')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
